import Vue from "vue";

Vue.prototype.$getMiniPosition = (minipath,noAddr=false) => {
  let jumpUrl = encodeURIComponent(window.location);
  // true代表不需要进选择地址页面
  let path;
  if(minipath){
    path = `${minipath}?noAddr=${noAddr}&jumpUrl=${jumpUrl}`;
  }else{
    path = `/pages/address/address?noAddr=${noAddr}&jumpUrl=${jumpUrl}`;
  }
  //使用navigateTo跳转到小程序路径中
  window.wx.miniProgram.navigateTo({
    url: path
  });
};


Vue.prototype.$getPosition = (noAddr = true) => {
    let path = "/pages/address/address";
    //
    // let noAddr = true;
    Vue.prototype.$getMiniPosition(path, noAddr);
};

Vue.prototype.$getPositonResult = (to) => {
  // alert(to.query.lat)
    if (to.query.lat && to.query.lng) {
      let position = {
          lat: to.query.lat,
          lng: to.query.lng
      };
      return position
    }
    return null
};

Vue.prototype.$getUpdateAddress = (to,from,next) => {
  if(to.query.address && to.query.lat && to.query.lng){
    let position = {
      address: to.query.address,
      lat: to.query.lat,
      lng: to.query.lng
    };
    return position
  }
  return null
}


// WEBPACK FOOTER //
// ./src/globalFuc/getPostion.js